export class IntendedProvider {
  public name?: string;
  public provider_id?: string;
  public location_id?: string;
  public client_canonical_id?: string;
  public client_canonical_id_source?: string;
  public member_cost?: number;
  public procedure_cost?: number;
  public employer_cost?: number;
  public incentive_amount?: number;
  public addr_line1?: string;
  public city?: string;
  public state?: string;
  public zip?: string;
  public phone?: string;
  public latitude?: number;
  public longitude?: number;
  public identifiers?: string[];
  public bdc_info?: string;
  public cash_reward_reference_number?: string;

  constructor(obj: IntendedProvider) {
    this.name = obj.name || null;
    this.provider_id = obj.provider_id || null;
    this.location_id = obj.location_id || null;
    this.client_canonical_id = obj.client_canonical_id || null;
    this.client_canonical_id_source = obj.client_canonical_id_source || null;
    this.member_cost = obj.member_cost || null;
    this.procedure_cost = obj.procedure_cost || null;
    this.employer_cost = obj.employer_cost || null;
    this.incentive_amount = obj.incentive_amount || null;
    this.addr_line1 = obj.addr_line1 || null;
    this.city = obj.city || null;
    this.state = obj.state || null;
    this.zip = obj.zip || null;
    this.phone = obj.phone || null;
    this.latitude = obj.latitude || null;
    this.longitude = obj.longitude || null;
    this.identifiers = obj.identifiers || null;
    this.bdc_info = obj.bdc_info || null;
    this.cash_reward_reference_number =
      obj.cash_reward_reference_number || null;
  }
}
